import React from 'react';

/**
 * WizardScenery — low-poly 3D scenery layers rendered in Blender
 * (see prototypes/stylized-earth.blend, scene "WizardScenery").
 * Faceted ocean waves (front + back parallax) and chunky clouds,
 * matching the stylized globe. Pure decoration: pointer-events none,
 * aria-hidden, animations disabled when reduced motion is requested.
 */
export default function WizardScenery({ reduced }) {
  return (
    <div style={s.wrap} aria-hidden="true">
      <div
        style={{
          ...s.clouds,
          ...(reduced ? {} : { animation: 'orboot-scenery-drift 26s ease-in-out infinite alternate' }),
        }}
      />
      <div
        style={{
          ...s.wavesBack,
          ...(reduced ? {} : { animation: 'orboot-scenery-sway 13s ease-in-out infinite alternate' }),
        }}
      />
      <div style={s.island} />
      <div
        style={{
          ...s.boat,
          ...(reduced ? {} : { animation: 'orboot-scenery-rock 5.5s ease-in-out infinite alternate' }),
        }}
      />
      <div
        style={{
          ...s.wavesFront,
          ...(reduced ? {} : { animation: 'orboot-scenery-sway 8s ease-in-out infinite alternate-reverse' }),
        }}
      />
    </div>
  );
}

const s = {
  wrap: {
    position: 'absolute',
    inset: 0,
    overflow: 'hidden',
    borderRadius: 'inherit',
    pointerEvents: 'none',
    zIndex: 0,
  },
  clouds: {
    position: 'absolute',
    top: 6,
    left: '-3%',
    width: '106%',
    height: '30%',
    background: 'url("/wizard-scene/clouds.png") top center / 100% auto no-repeat',
    opacity: 0.9,
  },
  wavesBack: {
    position: 'absolute',
    bottom: -2,
    left: '-4%',
    width: '108%',
    height: '21%',
    background: 'url("/wizard-scene/waves-back.png") bottom center / cover no-repeat',
    opacity: 0.75,
  },
  wavesFront: {
    position: 'absolute',
    bottom: -2,
    left: '-4%',
    width: '108%',
    height: '15%',
    background: 'url("/wizard-scene/waves-front.png") bottom center / cover no-repeat',
    opacity: 0.9,
  },
  island: {
    position: 'absolute',
    right: '-3%',
    bottom: '10%',
    width: 'clamp(140px, 24%, 280px)',
    aspectRatio: '1 / 1',
    background: 'url("/wizard-scene/island.png") bottom center / contain no-repeat',
  },
  boat: {
    position: 'absolute',
    left: '7%',
    bottom: '11%',
    width: 'clamp(70px, 11%, 130px)',
    aspectRatio: '1 / 1',
    background: 'url("/wizard-scene/boat.png") bottom center / contain no-repeat',
  },
};
